export default __webpack_public_path__ + "static/media/yellow-4.b326be60.png";